// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eM-z","hovered":"fM-z","hoverImage":"gM-z","mainImage":"hM-z","imageNoBackground":"iM-z","fullSizeImage":"jM-z"};